import {store} from './store'
import {setField, drag} from '../action_creators'

export function dropHandle(result) {
  const state = store.getState()
  // drop happened outside a dropzone
  if (!result.destination) {
    console.log(`You dropped an item outside the droppable area!`)
  } else {
    const {fields} = state
    const {droppableId: dest} = result.destination
    const {droppableId: src} = result.source

    const dId = result.draggableId.split(`prefix`)[1]
    
    // Safety check: Ensure source image exists
    if (!fields[src]?.images?.[dId]) {
      console.warn(`Source image with ID ${dId} not found in ${src}.`);
      return; // Or handle appropriately
    }

    const destImages = fields[dest].images
      ? {...fields[dest].images, [dId]: fields[src].images[dId]}
      : {[dId]: fields[src].images[dId]}

    // Create a new field object without mutating the original
    const newDestField = {
      ...fields[dest],
      images: destImages
    };

    // uncomment the next line if we only want a given image used in one location on an intake
    // (Note: If uncommenting, do this immutably by creating a new src field and dispatching another setField for src)
    // delete fields[src].images[dId]; // But this would mutate—fix similarly if needed

    store.dispatch(setField(dest, newDestField))
  }

  store.dispatch(drag(false))
}